import { createAction, props } from '@ngrx/store';
import { ObjektId } from '@models/objekt-id';
import { ReferencesResult } from 'app/core/services/api-client';

export const showReferences = createAction(
  '[References] Show references',
  props<{ id: ObjektId }>()
);

export const showReferencesSuccess = createAction(
  '[References] Show references (Success)',
  props<{ result: ReferencesResult }>()
);

export const loadMore = createAction(
  '[References] Load more'
);

export const loadMoreSuccess = createAction(
  '[References] Load more (Success)',
  props<{ result: ReferencesResult }>()
);
